<template>
  <section class="admin-panel form">
    <mdb-container>
      <mdb-row>
        <mdb-col md="12">
          <h1 class="text-left">
            <strong>Profile</strong>
          </h1>
          <h6 class="mb-5">
            <router-link to="/admin/profiles">
              <mdb-icon icon="arrow-left" />Back
            </router-link>| Editing:
            <span class="text-uppercase">{{id}}</span>
          </h6>
          <!-- Default input name -->
          <mdb-row class>
            <mdb-col md="6" class="py-3 pr-md-5">
              <label for="name" class="grey-text">Email</label>
              <input required type="text" v-model="id" id="name" class="form-control" readonly />
            </mdb-col>
            <mdb-col md="6" class="py-3 white">
              <label for="vimeoId" class="grey-text">Team members (enter email addresses to define)</label>
              <template v-for="(item, index) in membersArr">
                <div>{{membersArr[index]}}</div>
                <mdb-btn
                  @click="mthRemoveMember(membersArr[index])"
                  color="white"
                  class="btn-sm my-4"
                  rounded
                  :key="'button'+index"
                  icon="trash round-click bg-red"
                ></mdb-btn>

                <mdb-icon
                  v-if="false"
                  title="remove this member"
                  icon="trash round-click bg-red"
                  :key="'buttontrash'+index"
                  @click="mthRemoveMember(membersArr[index])"
                ></mdb-icon>

                <hr />
              </template>
              <input label="add new member" type="text" v-model="newMemberEmailToAdd" />
            </mdb-col>
          </mdb-row>

          <mdb-row>
            <mdb-btn @click="saveProfile" color="primary" class="btn-sm my-4" rounded>Save</mdb-btn>
            <router-link to="/admin/profiles">
              <mdb-btn color="primary" class="btn-sm my-4" rounded>Back to list</mdb-btn>
            </router-link>
          </mdb-row>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
  mdbTbl,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbInput
} from "mdbvue";
import firebase from "firebase/app";
import { store } from "../store";
import Player from "@vimeo/player";

export default {
  name: "AdminProfilesEdit",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
    mdbTbl,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbInput
  },
  data() {
    return {
      modal: false,
      newOrEditedProfile: {},
      lblCaptionMemberPlaceholder: "Member email",
      membersArr: [],
      newMemberEmailToAdd: "",
      id: ""
    };
  },
  methods: {
    mthRefreshStoreIamtheboss() {
      var memberscounter = 0;

      if (this.membersArr) memberscounter = this.membersArr.length;

      if (memberscounter === 0) {
        this.$store.commit("setIamtheboss", false);
      } else {
        this.$store.commit("setIamtheboss", true);
      }
    },
    mthRemoveMember(email) {
      //list.splice( list.indexOf('foo'), 1 );

      // this.newOrEditedProfile.team.splice(
      //   this.newOrEditedProfile.team.indexOf(email),
      //   1
      // );

      this.membersArr.splice(this.membersArr.indexOf(email), 1);

      this.newOrEditedProfile.team = this.membersArr;

      firebase
        .firestore()
        .collection("usersProfiles")
        .doc(this.$router.currentRoute.params.profileid)
        .update(this.newOrEditedProfile);

      this.mthRefreshStoreIamtheboss();
    },
    saveProfile() {
      console.log("save clicked");

      console.log("newMemberEmailToAdd=" + this.newMemberEmailToAdd);

      if (this.newMemberEmailToAdd != "")
        this.membersArr.push(this.newMemberEmailToAdd);

      if (!this.newOrEditedProfile.team) this.newOrEditedProfile.team = [];
      //   this.newOrEditedProfile.doc(this.id).set({ team: [] }, { merge: true });

      this.newOrEditedProfile.team.push(this.newMemberEmailToAdd);

      firebase
        .firestore()
        .collection("usersProfiles")
        .doc(this.$router.currentRoute.params.profileid)
        .update(this.newOrEditedProfile);

      alert("Profile updated");

      this.newMemberEmailToAdd = "";
      this.mthRefreshStoreIamtheboss();
    }
  },
  created() {
    firebase
      .firestore()
      .collection("usersProfiles")
      .doc(this.$router.currentRoute.params.profileid)
      .get()
      .then(result => {
        this.newOrEditedProfile = result.data();

        this.id = result.id;

        this.membersArr = [];

        if (result.data().team)
          result.data().team.forEach(el => {
            console.log("pushin " + el);

            this.membersArr.push(el);
          });
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}

.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}
</style>
